import { useEffect } from 'react';
import { Environment } from 'react-relay';
import CheckoutMutationWrapper from '../mutations/CheckoutMutationWrapper';
import { useGuestOrLoggedInUserId } from '../helpers/checkoutGuestUserToken';
import { useCheckoutSelector } from '../reducers/root';

export function useCheckoutVisitTracking({
    itemId,
    isMobile,
    relayEnvironment,
}: {
    itemId: string;
    isMobile: boolean;
    relayEnvironment: Environment;
}): void {
    const buyerId = useGuestOrLoggedInUserId();
    const isCheckoutReady = useCheckoutSelector(state => state.ui.isCheckoutReady);

    useEffect(() => {
        if (buyerId && isCheckoutReady) {
            CheckoutMutationWrapper.commit(
                'ReportCheckoutMutation',
                relayEnvironment,
                {
                    itemId,
                    buyerId,
                    type: 'CHECKOUT_ENTRY',
                },
                isMobile
            ).catch(() => {
                // ignore errors
            });
        }
    }, [buyerId, isCheckoutReady, isMobile, itemId, relayEnvironment]);
}
